/* =============================================================================
   pl-v3.js — tercera ronda: mazo de reseñas, videos infinitos, números, cinta 3D
   ========================================================================== */
(function () {
  'use strict';
  var ONX = (window.ONX = window.ONX || {});
  ONX.scenes = ONX.scenes || {};
  var A = function () { return window.anime; };

  /* ================================ reseñas: cartas que se deslizan (deck) */
  function initDeck(root) {
    root.querySelectorAll('[data-pdk]').forEach(function (box) {
      if (box._ok) return; box._ok = true;
      var stack = box.querySelector('.pdk__stack');
      var cards = Array.prototype.slice.call(stack.querySelectorAll('.plr__card'));
      var n = cards.length; if (!n) return;
      var order = cards.slice(), shown = 0, busy = false, lastTouch = 0, visible = false;
      var counter = box.querySelector('[data-pdk-i]');
      var secs = Number(box.getAttribute('data-pdk')) || 0;

      function fitHeight() {
        var h = 0; cards.forEach(function (c) { h = Math.max(h, c.offsetHeight); });
        stack.style.setProperty('--pdk-h', (h + 30) + 'px');
      }
      function pose(c, depth) {
        var d = Math.min(depth, 3);
        return { x: 0, y: d * 12, rotate: depth === 0 ? 0 : (depth % 2 ? 2.5 : -2.5), scale: 1 - d * 0.05, opacity: depth > 2 ? 0 : 1 };
      }
      function layout(animate) {
        order.forEach(function (c, i) {
          c.style.zIndex = String(100 - i);
          var p = pose(c, i);
          if (animate && A()) A().animate(c, { translateX: p.x, translateY: p.y, rotate: p.rotate, scale: p.scale, opacity: p.opacity, duration: 520, ease: 'outQuint' });
          else if (A()) A().utils.set(c, { translateX: p.x, translateY: p.y, rotate: p.rotate, scale: p.scale, opacity: p.opacity });
          else { c.style.transform = 'translate(' + p.x + 'px,' + p.y + 'px) rotate(' + p.rotate + 'deg) scale(' + p.scale + ')'; c.style.opacity = p.opacity; }
        });
        if (counter) counter.textContent = String(shown % n + 1);
      }
      function next(dir) {
        if (busy) return; busy = true;
        var top = order[0];
        var done = function () {
          order.push(order.shift()); shown++;
          layout(true);
          busy = false;
        };
        if (!A()) { done(); return; }
        A().animate(top, { translateX: dir * (stack.offsetWidth * 1.3), translateY: -30, rotate: dir * 20, opacity: 0, duration: 520, ease: 'inQuad',
          onComplete: function () { top.style.zIndex = '1'; done(); } });
      }
      function prev() {
        if (busy) return; busy = true;
        var last = order.pop(); order.unshift(last); shown = (shown - 1 + n) % n;
        last.style.zIndex = '200';
        if (A()) {
          A().animate(last, { translateX: [-stack.offsetWidth * 1.3, 0], translateY: [-30, 0], rotate: [-20, 0], opacity: [0, 1], scale: [1, 1], duration: 520, ease: 'outQuint',
            onComplete: function () { busy = false; layout(true); } });
          order.slice(1).forEach(function (c, i) { var p = pose(c, i + 1); A().animate(c, { translateY: p.y, scale: p.scale, rotate: p.rotate, opacity: p.opacity, duration: 520, ease: 'outQuint' }); });
        } else { busy = false; layout(false); }
      }

      // arrastrar con el dedo o el mouse
      var drag = null;
      stack.addEventListener('pointerdown', function (e) {
        var top = order[0]; if (busy || !top.contains(e.target)) return;
        drag = { x0: e.clientX, y0: e.clientY, dx: 0, card: top, id: e.pointerId, horiz: null };
        lastTouch = Date.now();
      });
      stack.addEventListener('pointermove', function (e) {
        if (!drag) return;
        drag.dx = e.clientX - drag.x0;
        var dy = e.clientY - drag.y0;
        if (drag.horiz === null && (Math.abs(drag.dx) > 6 || Math.abs(dy) > 6)) {
          drag.horiz = Math.abs(drag.dx) > Math.abs(dy);
          if (drag.horiz) stack.setPointerCapture(drag.id); else { drag = null; return; }
        }
        if (!drag.horiz) return;
        if (A()) A().utils.set(drag.card, { translateX: drag.dx, translateY: -Math.abs(drag.dx) * 0.05, rotate: drag.dx / 14 });
        else drag.card.style.transform = 'translate(' + drag.dx + 'px,0) rotate(' + (drag.dx / 14) + 'deg)';
      });
      function release() {
        if (!drag) return;
        var d = drag; drag = null;
        if (!d.horiz) return;
        if (Math.abs(d.dx) > 90) next(d.dx > 0 ? 1 : -1);
        else if (A()) A().animate(d.card, { translateX: 0, translateY: 0, rotate: 0, duration: 700, ease: 'outElastic(1, .6)' });
        else d.card.style.transform = '';
      }
      stack.addEventListener('pointerup', release);
      stack.addEventListener('pointercancel', release);

      box.querySelector('[data-pdk-next]').addEventListener('click', function () { lastTouch = Date.now(); next(1); });
      box.querySelector('[data-pdk-prev]').addEventListener('click', function () { lastTouch = Date.now(); prev(); });
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.4 }).observe(stack);

      // pasan solas, alternando izquierda y derecha
      if (secs > 0) {
        var lado = -1;
        setInterval(function () {
          if (!visible || document.hidden || Date.now() - lastTouch < 6000) return;
          next(lado); lado = -lado;
        }, secs * 1000);
      }
      fitHeight(); layout(false);
      window.addEventListener('resize', fitHeight);
      cards.forEach(function (c) { var im = c.querySelector('img'); if (im && !im.complete) im.addEventListener('load', fitHeight, { once: true }); });
    });
  }

  /* ====================================== videos: carrusel infinito con flechas */
  function initVideos(root) {
    root.querySelectorAll('[data-pvi]').forEach(function (box) {
      if (box._ok) return; box._ok = true;
      var row = box.querySelector('.pvi__row');
      var cards = Array.prototype.slice.call(row.querySelectorAll('.pvi__card'));
      var n = Number(box.getAttribute('data-n')) || 1, sets = cards.length / n;
      var auto = Number(box.getAttribute('data-auto')) || 0, lastTouch = 0, visible = false, center = null;
      var step = function () { return cards[1].offsetLeft - cards[0].offsetLeft; };
      var setW = function () { return step() * n; };
      function toCard(c, smooth) { row.scrollTo({ left: c.offsetLeft - (row.clientWidth - c.offsetWidth) / 2, behavior: smooth ? 'smooth' : 'auto' }); }
      function paint() {
        var mid = row.scrollLeft + row.clientWidth / 2, best = null, bd = 1e9;
        cards.forEach(function (c) { var d = Math.abs(c.offsetLeft + c.offsetWidth / 2 - mid); if (d < bd) { bd = d; best = c; } });
        if (best !== center) {
          if (center) center.classList.remove('is-center');
          center = best; center.classList.add('is-center');
          cards.forEach(function (c) { var v = c.querySelector('video'); if (!v) return; if (c === center && visible) { if (v.preload === 'none') v.preload = 'metadata'; v.play().catch(function () {}); } else v.pause(); });
        }
      }
      // al terminar de deslizar, si se salió del bloque del medio, salta sin que se note
      var t = null, raf = null;
      row.addEventListener('scroll', function () {
        if (!raf) raf = requestAnimationFrame(function () { raf = null; paint(); });
        clearTimeout(t);
        t = setTimeout(function () {
          var w = setW(), mid0 = w * Math.floor(sets / 2);
          if (row.scrollLeft < mid0 - w * 0.5) row.scrollLeft += w;
          else if (row.scrollLeft > mid0 + w * 0.5) row.scrollLeft -= w;
          paint();
        }, 140);
      }, { passive: true });
      function go(dir) { lastTouch = Date.now(); row.scrollBy({ left: dir * step(), behavior: 'smooth' }); }
      box.querySelector('[data-pvi-prev]').addEventListener('click', function () { go(-1); });
      box.querySelector('[data-pvi-next]').addEventListener('click', function () { go(1); });
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (e) { row.addEventListener(e, function () { lastTouch = Date.now(); }, { passive: true }); });
      row.addEventListener('click', function (e) {
        var b = e.target.closest('.plv__sound'); if (!b) return;
        var v = b.parentElement.querySelector('video');
        cards.forEach(function (c) { var o = c.querySelector('video'); if (o && o !== v) { o.muted = true; var ob = c.querySelector('.plv__sound'); if (ob) ob.classList.remove('is-on'); } });
        v.muted = !v.muted; b.classList.toggle('is-on', !v.muted);
      });
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; center = null; paint(); }, { threshold: 0.35 }).observe(row);
      requestAnimationFrame(function () { toCard(cards[n * Math.floor(sets / 2)], false); paint(); });
      if (auto > 0) setInterval(function () { if (visible && !document.hidden && Date.now() - lastTouch > 8000) row.scrollBy({ left: step(), behavior: 'smooth' }); }, auto * 1000);
    });
  }

  /* ============================================== los números: anillos */
  function initCifras(root) {
    root.querySelectorAll('[data-pcf2] .pcf2__it').forEach(function (it) {
      if (it._ok) return; it._ok = true;
      new IntersectionObserver(function (en, ob) { if (en[0].isIntersecting) { ob.disconnect(); it.classList.add('is-in'); } }, { threshold: 0.4 }).observe(it);
    });
  }

  function init(root) { root = root || document; initDeck(root); initVideos(root); initCifras(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  /* ================================== frases: las cintas se inclinan con el scroll */
  ONX.scenes['pl-frases3d'] = function (el, gsap) {
    var b1 = el.querySelector('.ptk__band--1'), b2 = el.querySelector('.ptk__band--2');
    var st = { trigger: el, start: 'top bottom', end: 'bottom top', scrub: 0.6 };
    if (b1) gsap.fromTo(b1, { rotateX: 28, rotateZ: -6, y: 20 }, { rotateX: 4, rotateZ: -1.5, y: -10, ease: 'none', scrollTrigger: st });
    if (b2) gsap.fromTo(b2, { rotateX: -26, rotateZ: 5, y: -10 }, { rotateX: -4, rotateZ: 1.5, y: 10, ease: 'none', scrollTrigger: Object.assign({}, st) });
  };
})();
